import URLConfig from '../service/URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

class AdminService {

    // admin only: USER, MANAGER or ADMIN
    changeUserRole(userId, role) {
        return axiosInstance().put(path + "/admin/users/" + userId + "/role", { role: role });
    }

    // admin only: ACTIVE or DISABLED (a disabled user is signed out and can't log in)
    changeUserStatus(userId, status) {
        return axiosInstance().put(path + "/admin/users/" + userId + "/status", { status: status });
    }

}

export default new AdminService()